export default class ValuationReport {
    constructor({request, response, userEmail, visitorType, isVisitor, reportComment, reportSuggestedPrice}) {
        let maxAsNr, minAsNr
        if(!isNaN(reportSuggestedPrice.min)) minAsNr = parseFloat(reportSuggestedPrice.min)
        else minAsNr = reportSuggestedPrice.min

        if(!isNaN(reportSuggestedPrice.max)) maxAsNr = parseFloat(reportSuggestedPrice.max)
        else maxAsNr = reportSuggestedPrice.max

        if(request)this.request = request  
        if(response)this.response = response 
        if(userEmail)this.userEmail = userEmail
        if(visitorType)this.visitorType = visitorType
        if(isVisitor)this.isVisitor = isVisitor
        if(reportComment)this.reportComment = reportComment
        this.reportSuggestedPrice = {
            min: minAsNr,
            max: maxAsNr
        }
    }
}
  


// WEBPACK FOOTER //
// ./src/pricing/vo/ValuationReport.js